import { useState } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";
import { StatusBadge } from "../StatusBadge";

const ROW = {
  added: "bg-emerald-950/40 text-emerald-200 border-l-2 border-emerald-500",
  removed: "bg-rose-950/40 text-rose-300 line-through border-l-2 border-rose-500",
  modified: "bg-amber-950/40 text-amber-200 border-l-2 border-amber-500",
  equal: "text-slate-400",
};

function Cell({ text, type }) {
  if (text == null) return <div className="p-2 my-1 text-slate-700 text-xs italic">—</div>;
  return <div className={`p-2 my-1 rounded-r text-sm leading-relaxed manuscript ${ROW[type]}`}>{text}</div>;
}

function ChapterDiff({ c, i }) {
  const [open, setOpen] = useState(c.status !== "unchanged");
  const [showEqual, setShowEqual] = useState(false);
  const rows = showEqual ? c.rows : c.rows.filter((r) => r.type !== "equal");
  return (
    <div className="border border-slate-800 rounded-lg" data-testid={`diff-chapter-${i}`}>
      <button className="w-full flex items-center justify-between gap-3 p-3 text-left" onClick={() => setOpen(!open)}>
        <span className="flex items-center gap-2 text-sm text-slate-200">{open ? <ChevronDown size={14} /> : <ChevronRight size={14} />}{c.title_b || c.title_a}</span>
        <span className="flex items-center gap-2 text-xs font-mono text-slate-500">
          {c.words_a} → {c.words_b} w · +{c.stats.added || 0} −{c.stats.removed || 0} ~{c.stats.modified || 0}
          <StatusBadge status={c.status === "unchanged" ? "PASS" : c.status === "removed" ? "ERROR" : "WARNING"} label={c.status} />
        </span>
      </button>
      {c.notes?.length > 0 && <div className="px-3 pb-2">{c.notes.map((n) => <p key={n} className="text-xs text-warn-300">• {n}</p>)}</div>}
      {open && (
        <div className="px-3 pb-3">
          <label className="text-xs text-slate-500 flex gap-2 items-center mb-2"><input type="checkbox" checked={showEqual} onChange={(e) => setShowEqual(e.target.checked)} />Show unchanged paragraphs</label>
          {rows.length === 0 && <p className="text-xs text-slate-500">No differences.</p>}
          {rows.map((r, k) => (
            <div key={k} className="grid grid-cols-2 gap-3"><Cell text={r.left} type={r.type === "added" ? "equal" : r.type} /><Cell text={r.right} type={r.type === "removed" ? "equal" : r.type} /></div>
          ))}
        </div>
      )}
    </div>
  );
}

export function DiffView({ data }) {
  if (!data) return null;
  return (
    <div className="space-y-3" data-testid="diff-view">
      <div className="grid grid-cols-2 gap-3 text-xs eyebrow"><span>v{data.a.number} · {data.a.label}</span><span>v{data.b.number} · {data.b.label}</span></div>
      {data.chapters.map((c, i) => <ChapterDiff key={i} c={c} i={i} />)}
    </div>
  );
}
